/** 页面内容导航：复用书籍管理的下划线 Tab 样式，计数与标签分层显示。 */
export function PageTabs<T extends string>({
  label,
  value,
  items,
  onChange,
}: {
  label: string;
  value: T;
  items: readonly { id: T; label: string; count?: number | null }[];
  onChange: (value: T) => void;
}) {
  return (
    <div className="page-tabs" role="tablist" aria-label={label}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={value === item.id}
          onClick={() => onChange(item.id)}
        >
          {item.label}
          {item.count != null && <span className="mono page-tab-count"> · {item.count}</span>}
        </button>
      ))}
    </div>
  );
}
